var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartOfAccountsV2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 21v-1.875c0-1.035 1.12-1.875 2.5-1.875H21M16 21H9a2 2 0 01-2-2v-9a2 2 0 012-2h10a2 2 0 012 2v7.25M16 21l2-1.5 3-2.25",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13h2M7 13.707l-2.608.522A2 2 0 012 12.268V5.36c0-.608.541-1.073 1.147-1.019 5.675.507 7.06-1.815 12.01-1.252a.963.963 0 01.843.965v3.153",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5.207v0a2 2 0 01-2 2H2M5 13.207v0a2 2 0 00-2-2H2M13 3.207v1a2 2 0 002 2h1M11.5 11.921c.828 0 1.5.577 1.5 1.29m-1.5-1.29c-.828 0-1.5.577-1.5 1.29 0 .712.672 1.289 1.5 1.289s1.5.577 1.5 1.29c0 .712-.672 1.289-1.5 1.289m0-5.158V11m0 6.079c-.828 0-1.5-.577-1.5-1.29m1.5 1.29V18",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
export default SvgChartOfAccountsV2;